import React, { ReactNode } from 'react';
import { ContentStyled, LayoutWrapperStyled } from './styles';

interface GlobalLayoutProps {
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  /* @deprecated: Extend with styled-components instead. Remove if it's no longer used. */
  contentStyle?: string;
}

/** @deprecated: use page layouts from the components library instead */
const GlobalLayout: React.FC<GlobalLayoutProps> = ({ leftSection, rightSection, contentStyle }) => {
  return (
    <LayoutWrapperStyled>
      {leftSection}
      <ContentStyled className={contentStyle}>{rightSection}</ContentStyled>
    </LayoutWrapperStyled>
  );
};

export default GlobalLayout;
